const deleteProject = async ({projectId, setProjects}) => {
  try {
    const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';
    const response = await fetch(`${API_BASE_URL}/deleteProject`, {
      method: 'POST',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        "X-API-SECRET": process.env.REACT_APP_NXTVID_API_SECRET,
      },
      body: JSON.stringify({ projectId }),
    });
    const result = await response.json();
    console.log(result.projectId);
    console.log(projectId)
    setProjects(prevProjects => prevProjects.filter(project => project._id !== projectId));
  } catch (error) {
    console.error('Error: ', error);
  }
}

export default deleteProject;